import {Stomp} from './stomp';


function WebSocketManager() {
    this.onTrueError = function() {};
    this.onFalseError = function() {};
}


WebSocketManager.prototype.createWS = function(){
    var self = this;

    try{
        self.ws = new WebSocket(self.config['stomp']['url_ws']);
    }catch(e){
        self.onTrueError();

        console.log(e);
        setTimeout(function(){
            self.createWS();
        }, 3000);
    }
};

WebSocketManager.prototype.init = function(){
    var self = this;

    return new Promise(function(outerResolve) {
        new Promise(function(innerResolve){
            self.createWS();

            if(self.ws){
                innerResolve();
            }
        }).then(function(){
            self.client = Stomp.over(self.ws);
            //self.client.heartbeat.outgoing = 0;
            //self.client.heartbeat.incoming = 0;

            self.client.debug = function(m) {
                if(m === '>>> PING' || m === '<<< PONG')
                    return;
                console.log(m);
            };
            self.connect().then(function() { outerResolve(); });
        });
    });
};

WebSocketManager.prototype.connect = function(){
    var self = this;

    return new Promise(function(resolve, reject) {
        self.client.connect(self.config['stomp']['login'], self.config['stomp']['password'],
            function(){
                if(typeof self.onFalseError === 'function') {
                    self.onFalseError();
                }
                if(typeof self.onConnect === 'function') {
                    self.onConnect();
                }
                resolve();
            }, function(error){
                if(typeof self.onTrueError === 'function') {
                    self.onTrueError();
                }
                if(typeof self.onError === 'function') {
                    self.onError(error);
                }
                reject(error);
            },
            self.config['stomp']['virtual_host']
        );
    });
};


WebSocketManager.prototype.onError = function(error){
    console.log('RABBIT ERROR', error);
    this.reconnect();
};

WebSocketManager.prototype.disconnect = function() {
    var self = this;

    if(self.exchange){
        self.exchange = null;
    }

    if(self.client){
        self.client = null;
    }

    if(self.ws){
        self.ws.close();
        self.ws = null;
    }
}

WebSocketManager.prototype.reconnect = function(){
    var self = this;

    self.disconnect();

    self.init();
};

export default WebSocketManager;
